import { ClassValue } from 'clsx';
import { ScrollArea as RdxScrollArea } from 'radix-ui';
import React from 'react';
import cn from '../../app/utils/cn';

interface IScrollAreaProps {
  children: React.ReactNode;
  className?: ClassValue;
  hidden?: boolean;
}
export default function ScrollArea({
  children,
  className,
  hidden = false,
}: IScrollAreaProps) {
  return (
    <RdxScrollArea.Root
      className={cn('min-h-0 flex-1', className)}
      scrollHideDelay={300}
    >
      <RdxScrollArea.Viewport className="size-full p-2">
        {children}
      </RdxScrollArea.Viewport>
      <RdxScrollArea.Scrollbar
        hidden={hidden}
        className="bg-grey-50 hover:bg-grey-100 dark:bg-grey-700 dark:hover:bg-grey-600 flex touch-none rounded transition-colors duration-160 ease-out select-none data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:flex-col data-[orientation=vertical]:w-1"
        orientation="vertical"
      >
        <RdxScrollArea.Thumb className="bg-grey-300 dark:bg-grey-500 relative flex-1 rounded before:absolute before:top-1/2 before:left-1/2 before:size-full before:min-h-8 before:min-w-8 before:-translate-x-1/2 before:-translate-y-1/2" />
      </RdxScrollArea.Scrollbar>
      <RdxScrollArea.Scrollbar
        hidden={hidden}
        className="bg-grey-50 hover:bg-grey-100 dark:bg-grey-700 dark:hover:bg-grey-600 flex touch-none rounded transition-colors duration-160 ease-out select-none data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:flex-col data-[orientation=vertical]:w-1"
        orientation="horizontal"
      >
        <RdxScrollArea.Thumb className="bg-grey-300 dark:bg-grey-500 relative flex-1 rounded before:absolute before:top-1/2 before:left-1/2 before:size-full before:min-h-8 before:min-w-8 before:-translate-x-1/2 before:-translate-y-1/2" />
      </RdxScrollArea.Scrollbar>
      <RdxScrollArea.Corner className="bg-grey-500" />
    </RdxScrollArea.Root>
  );
}
